import Glide from "@glidejs/glide";

export function init() {
  const sliders = document.querySelectorAll(".glide");

  if (!sliders) {
    return;
  }
  Object.values(sliders).map(function (slider) {
    const options = JSON.parse(slider.dataset.options);
    const glide = new Glide(slider, options);

    glide.on(["build.before", "run"], function () {
      var cb = eval(slider.dataset.callback);
      if (typeof cb == "function") {
        cb(glide, slider);
      }
    });

    glide.on("build.after", function () {
      glideHandleHeight();
    });

    // Automated height on Carousel change
    glide.on("run.after", function () {
      glideHandleHeight();
    });

    // Mount!
    glide.mount();

    function glideHandleHeight() {
      const activeSlide = slider.querySelector(".glide__slide--active");
      const activeSlideHeight = activeSlide ? activeSlide.offsetHeight : 0;
      const glideTrack = slider.querySelector(".glide__track");
      const glideTrackHeight = glideTrack ? glideTrack.offsetHeight : 0;
      if (activeSlideHeight !== glideTrackHeight) {
        glideTrack.style.height = `${activeSlideHeight}px`;
      }
    }
  });
}
